import Modal from '../../../components/shared/modal'
import UserPasswordChange from './password-change'
import { logout } from '../../../components/shared/auth'

interface Props {
    handleHideModal?: () => void
    keyboard?: boolean
    backdrop?: boolean | 'static'
}

const UserPasswordChangeModal = ({
    handleHideModal,
    keyboard = false,
    backdrop = 'static',
}: Props) => (
    <Modal
        dialogClass="modal-lg"
        handleHideModal={() => (handleHideModal ? handleHideModal() : logout())}
        keyboard={keyboard}
        backdrop={backdrop}
        content={() => (
            <div className="p-3">
                <UserPasswordChange />
            </div>
        )}
    />
)

export default UserPasswordChangeModal
